import { isISODateString } from "./../../helpers/dateHelpers";
import dayjs from "dayjs";

// Arrow function to convert date properties to DayJS
export const convertDatesToDayJS = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(convertDatesToDayJS);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      // Regular expression to match ISO date strings or YYYY-MM-DD format
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
      const simpleDateRegex = /^\d{4}-\d{2}-\d{2}$/;

      if (
        typeof value === "string" &&
        (isoDateRegex.test(value) || simpleDateRegex.test(value))
      ) {
        acc[key] = dayjs(value);
      } else if (value instanceof Date) {
        acc[key] = dayjs(value);
      } else {
        acc[key] = convertDatesToDayJS(value);
      }
      return acc;
    }, {} as any);
  }

  return obj;
};

export const convertDatesToString = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(convertDatesToString);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      if (dayjs.isDayjs(value) || value instanceof Date) {
        acc[key] = dayjs(value).utc().format(); // UTC ISO string format
      } else {
        acc[key] = convertDatesToString(value);
      }
      return acc;
    }, {} as any);
  }
  return obj;
};
